import { Injectable } from '@angular/core';
import { FileService } from 'src/app/services/api/file.service';

@Injectable({ providedIn: 'root' })
export class FileDetailRepository {
  constructor(private readonly fileService: FileService) {}

  getBibliaByItineraryId(itineraryId: string) {
    return this.fileService.getBibliaByItineraryId(itineraryId);
  }

  getFlightsByItineraryId(id: any) {
    return this.fileService.getFlightsByItineraryId(id);
  }

  getProgrammingServicesAndOrdersByFile(fileId: string) {
    return this.fileService.getProgrammingServicesAndOrdersByFile(fileId);
  }

  getDetailsByFile(id: any) {
    return this.fileService.getDetailsByFile(id);
  }

  getActivitiesByIdItinerary(id: any) {
    return this.fileService.getActivitiesByIdItinerary(id);
  }

  getFlightsById(id: string) {
    return this.fileService.getFlightsById(id);
  }

  getPassengersByIds(payload: any) {
    return this.fileService.getPassengersByIds(payload);
  }

  getChildFilesBySsffId(ssffId: any) {
    return this.fileService.getChildFilesBySsffId({ ssffId });
  }

  getServiceFilesHijos(fileHijoId: any) {
    return this.fileService.getServiceFilesHijos(fileHijoId);
  }
}
